/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import SimpleButton from '@components/Buttons/SimpleButton';
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import config from '@config';

/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const ProgramFeeV1 = ({ sectionContent, region, language, pageData }) => {
    // console.log("the sec in prgram fee", sectionContent)
    const pageName = pageData?.pageConfig?.pageName
    return (
        <Box
            //marginTop="-35px"
            paddingTop={{ base: "110px", sm: "110px", md: "110px" }}
            paddingBottom={"60px"}
            background={"#F6EDDE"}
            bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835026-left_testimonials.png)`}}
            bgRepeat={'no-repeat'}
            bgPosition={'left 80px'}
        >
            <Box
                width={{ sm: "auto", base: "auto", md: "auto" }}
                color="#262626"
                fontWeight={'500'}
                fontSize={{base:"32px",md:"32px",sm:"30px",lg:"32px"}}
                mx={{ base: '17px', md: 'auto' }}
                lineHeight={{ base: "37px", sm: "37px", md: "37px" }}
                fontFamily={'FedraSansStd-A-medium'}
                textAlign={'center'}
            >
                {sectionContent[0].titleText}
            </Box>
            {/* <SectionTitle
                titleObj={sectionContent[0]}
                color="#262626"
                titleDecoration={sectionContent[0]?.titleDecoration}
                mx={{ base: '17px', md: 'auto' }}
                fontSize={{ base: "30px", sm: "30px", md: "" }}
                marginTop={'50px'}
            /> */}
            <Box marginTop={"-30px"}>
                <TopKolam
                    sectionContent={sectionContent[1]}
                />
            </Box>
            <Box display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexDirection={{ "base": "column", "sm": "column", "md": "row" }}
                gap={{base:"20px", sm:"20px",md:"0px", lg:"0px"}}
            >
                <Box
                    w={{ base: "320px", sm: "320px", md: "365px" }}
                    background={"white"}
                    //borderRadius={"6px"}
                    borderTopLeftRadius={"6px"}
                    borderBottomLeftRadius={"6px"}
                    textAlign={"center"}
                    maxH={"111px"}
                    height={'111px'}
                    fontFamily={'FedraSansStd-book'}
                    fontSize={'18px'}
                    color={'#6C6053'}
                    lineHeight={'30px'}
                >
                    <StructuredTextParser
                        sectionContent={sectionContent[2]}
                        str={render(sectionContent[2]?.body)}
                        textAlign={"center"}
                    />
                </Box>
                <Box
                    w={{ base: "320px", sm: "320px", md: "365px" }}
                    background={"white"}
                    //borderRadius={"6px"}
                    borderTopRightRadius={"6px"}
                    borderBottomRightRadius={"6px"}
                    textAlign={"center"}
                    maxH={"111px"}
                    height={'111px'}
                    fontFamily={'FedraSansStd-book'}
                    fontSize={'18px'}
                    color={'#6C6053'}
                    lineHeight={'30px'}
                >
                    <StructuredTextParser
                        sectionContent={sectionContent[3]}
                        str={render(sectionContent[3]?.body)}
                        textAlign={"center"}
                    />
                </Box>
            </Box>

            <Box //marginTop={{ base: "-40px", sm: "-40px", md: "-45px" }}
                width={{ sm: "100%", base: "100%", md: "437px" }}
                mx={"auto"}  
                fontStyle={'italic'}
                color={'#28231E'}
                fontSize={'16px'}
                lineHeight={'24px'}
                fontWeight={'350'}
                paddingTop={'40px'}
                marginBottom={'-100px'}
                fontFamily={'FedraSansPro'}
                textAlign={"center"}
                >
                {sectionContent[4].text}
            </Box>
                
            <Box
                marginTop={"20px"}
            >
                <SimpleButton
                    style={sectionContent[4]}
                    region={region}
                    lang={language}
                    mx="auto"
                    width={"188px"}
                    pageConfig={pageData?.pageConfig}
                />
            </Box>
            <Box
                mx={"auto"}
                color={"#28231E"}
                textAlign={"center"}
                width={{ base: "", sm: "", md: "600px" }}
                fontSize={"16px"}
                fontStyle={"italic"}
                fontFamily={"FedraSansStd-book"}
            >
                <Box textAlign={"center"}
                    color={"#28231E"}
                    fontSize={"16px"}
                    lineHeight={{ base: '27px', md: '29px' }}>
                    {sectionContent[5]?.body?.value?.document?.children[0]?.children[0]?.value}
                </Box>
            </Box>


            <style>
                {`
               
                   #program-fee h4 { 
                    color: #28231E;
                    text-align: center;
                    font-feature-settings: 'case' on;
                    font-family: "FedraSansStd-book";
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 30px;
                    padding-bottom: 4px;
                    padding-top: 8px;
                }
                }
                `}

            </style>
        </Box >

    );
};

export default ProgramFeeV1;
